
const levadas = [
  {
    id: 1,
    name: 'Levada do Caniçal',
    distance: '6.4 km',
    duration: '2h30',
    difficulty: 'Fácil',
    difficultyColor: 'text-nature-green bg-nature-green/10',
    startPoint: 'Machico',
    description: 'A levada mais próxima dos nossos alojamentos! Percurso plano ao longo de um canal de água com vistas deslumbrantes sobre o oceano e a baía de Machico.',
    image: 'https://public.readdy.ai/ai/img_res/cc54356ae76b019a2686c342868d883c.jpg',
    tips: 'Saída a 5 min dos apartamentos',
    tipColor: 'bg-nature-green',
  },
  {
    id: 2,
    name: 'Levada das 25 Fontes',
    distance: '11 km',
    duration: '4h',
    difficulty: 'Moderado',
    difficultyColor: 'text-amber-600 bg-amber-50',
    startPoint: 'Rabacal',
    description: 'Uma das levadas mais famosas da Madeira. Termina numa cascata espetacular rodeada de 25 nascentes naturais. Paisagem de outro mundo.',
    image: 'https://readdy.ai/api/search-image?query=Levada%20das%2025%20Fontes%20Madeira%20waterfall%2C%20stunning%20natural%20pool%20surrounded%20by%20lush%20green%20forest%2C%20crystal%20clear%20water%2C%20magical%20fairy%20tale%20landscape%2C%20hiking%20trail%2C%20tropical%20paradise%2C%20nature%20photography%2C%20misty%20atmosphere&width=700&height=450&seq=levada2&orientation=landscape',
    tips: 'Imperdível',
    tipColor: 'bg-amber-500',
  },
  {
    id: 3,
    name: 'Levada do Caldeirão Verde',
    distance: '13 km',
    duration: '5h',
    difficulty: 'Moderado',
    difficultyColor: 'text-amber-600 bg-amber-50',
    startPoint: 'Queimadas',
    description: 'Atravessa a floresta Laurissilva, Património Mundial da UNESCO. Termina numa cascata de 100m dentro de uma caldeira vulcânica. Experiência única.',
    image: 'https://readdy.ai/api/search-image?query=Caldeir%C3%A3o%20Verde%20Madeira%20levada%20trail%20through%20UNESCO%20Laurisilva%20forest%2C%20ancient%20laurel%20trees%2C%20misty%20green%20forest%2C%20dramatic%20waterfall%20inside%20volcanic%20crater%2C%20magical%20atmosphere%2C%20hiking%20adventure%2C%20lush%20vegetation%2C%20ethereal%20light&width=700&height=450&seq=levada3&orientation=landscape',
    tips: 'UNESCO',
    tipColor: 'bg-sea-blue',
  },
  {
    id: 4,
    name: 'Vereda do Areeiro',
    distance: '7.5 km',
    duration: '3h30',
    difficulty: 'Difícil',
    difficultyColor: 'text-rose-600 bg-rose-50',
    startPoint: 'Pico do Areeiro',
    description: 'A trilha mais icónica da Madeira. Liga os dois picos mais altos da ilha com vistas acima das nuvens. Paisagem lunar e pôr do sol inesquecível.',
    image: 'https://readdy.ai/api/search-image?query=Pico%20do%20Areeiro%20Madeira%20mountain%20peak%20above%20clouds%2C%20dramatic%20rocky%20volcanic%20landscape%2C%20panoramic%20view%20above%20cloud%20layer%2C%20sunrise%20golden%20light%2C%20epic%20mountain%20trail%2C%20adventure%20hiking%2C%20breathtaking%20scenery%2C%20high%20altitude%20landscape%20photography&width=700&height=450&seq=levada4&orientation=landscape',
    tips: 'Vista acima das nuvens',
    tipColor: 'bg-rose-500',
  },
];

const LevadasSection = () => {
  return (
    <section id="levadas" className="py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-nature-green text-xs font-semibold uppercase tracking-widest mb-3">Natureza & Trilhos</p>
          <h2 className="text-4xl md:text-5xl font-light text-gray-900 mb-4">
            Levadas & <span className="font-serif italic text-nature-green">Trilhos</span>
          </h2>
          <p className="text-gray-500 text-lg max-w-2xl mx-auto leading-relaxed">
            A Madeira tem mais de 2.500 km de levadas. Escolha o seu percurso e mergulhe na natureza mais selvagem da Europa.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {levadas.map((levada) => (
            <div
              key={levada.id}
              className="bg-white rounded-3xl overflow-hidden shadow-sm border border-gray-100 hover:shadow-xl transition-all duration-300 group"
            >
              <div className="relative w-full h-56 overflow-hidden">
                <img
                  src={levada.image}
                  alt={levada.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4">
                  <span className={`${levada.tipColor} text-white text-xs font-semibold px-3 py-1 rounded-full`}>
                    {levada.tips}
                  </span>
                </div>
              </div>
              <div className="p-6">
                <div className="flex items-start justify-between mb-3">
                  <h3 className="text-xl font-semibold text-gray-900">{levada.name}</h3>
                  <span className={`text-xs font-semibold px-3 py-1 rounded-full ${levada.difficultyColor}`}>
                    {levada.difficulty}
                  </span>
                </div>
                <p className="text-gray-500 text-sm leading-relaxed mb-5">{levada.description}</p>
                <div className="flex items-center gap-5 text-sm text-gray-600 border-t border-gray-100 pt-4">
                  <span className="flex items-center gap-1.5">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-map-pin-line text-sea-blue"></i>
                    </div>
                    {levada.startPoint}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-route-line text-sea-blue"></i>
                    </div>
                    {levada.distance}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-time-line text-sea-blue"></i>
                    </div>
                    {levada.duration}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-nature-green/10 border border-nature-green/20 rounded-2xl p-6 flex flex-col md:flex-row items-center gap-4">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-nature-green/20 shrink-0">
            <i className="ri-information-line text-nature-green text-2xl"></i>
          </div>
          <div>
            <p className="font-semibold text-gray-800 mb-1">Dica dos Anfitriões</p>
            <p className="text-gray-600 text-sm leading-relaxed">
              A Levada do Caniçal começa mesmo ao lado dos nossos apartamentos! Acorde cedo, calce umas sapatilhas confortáveis e parta para uma manhã inesquecível. Recomendamos levar água e protetor solar.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LevadasSection;
